// extracted by mini-css-extract-plugin
export var cell = "_6h-4";
export var headerCell = "_6h-2";
export var rowHeader = "_6h-3";
export var table = "_6h-1";
export var tableContainer = "_6h-0";